import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import moment from 'moment';
import { Place, RestaurantMenu } from '@material-ui/icons';
import { DayStepper, DropDownMenu } from '../../components';
import ButtonBadge from '../../components/button-badge';

const moreKey = 'more';
const dayKey = 'day';

class SubheaderPanel extends Component {
  get productionPlaces() {
    const { productionPlaces } = this.props;
    const places = productionPlaces.map(place => ({ name: place.name, value: place.productionPlaceId })).asMutable();
    places.unshift({ name: 'Alle', value: null });
    return places;
  }

  get spots() {
    const { spots } = this.props;
    const orderItems = spots.map(order => ({ name: order.spotName, value: order.spotName })).asMutable();
    const filtered = orderItems.filter((orderItem, index, arr) => arr.indexOf(orderItems.find(oItem => oItem.value === orderItem.value)) === index);
    filtered.unshift({ name: 'Alle', value: null });
    return filtered;
  }

  get settingString() {
    const { localSettings } = this.props;
    let string = `app-bar-tabs`;
    if (localSettings) {
      if (localSettings.showOrderSpotFilter && localSettings.showProductionPlaceFilter) {
        string += ' with-two-filter';
      } else if (localSettings.showOrderSpotFilter || localSettings.showProductionPlaceFilter) {
        string += ' with-one-filter';
      }
    }
    return string;
  }

  getModeToId(modeid) {
    const { selectedModeId } = this.props;
    if (selectedModeId === moreKey) {
      return moreKey;
    }
    const { selectableDurations } = this.props;
    return selectableDurations.filter(duration => duration.id === modeid)[0];
  }

  renderProductionPlaceFilterTab() {
    const {
      ordersProductionPlace,
      setProductionPlaceOrderFilter,
      localSettings,
    } = this.props;

    if (!localSettings || !localSettings.showProductionPlaceFilter) {
      return null;
    }

    return (
      <div className="filter-tab">
        <DropDownMenu
          iconLeft={<Place />}
          label="Produktionsplatz"
          items={this.productionPlaces}
          value={ordersProductionPlace}
          placeholder="Alle"
          onChange={(e, value, key) => {
            setProductionPlaceOrderFilter(key);
          }}
        />
      </div>
    );
  }

  renderOrderSpotFilterTab() {
    const {
      orderSpot,
      setOrderSpotFilter,
      localSettings,
    } = this.props;

    if (!localSettings || !localSettings.showOrderSpotFilter) {
      return null;
    }

    return (
      <div className="filter-tab">
        <DropDownMenu
          iconLeft={<RestaurantMenu />}
          label="Standort / Tisch"
          items={this.spots}
          value={orderSpot}
          placeholder="Alle"
          onChange={(e, value, key) => {
            setOrderSpotFilter(key);
          }}
        />
      </div>
    );
  }

  render() {
    const {
      selectableDurations,
      selectedModeId,
      setMode,
      ordersStartDate,
      classes,
      localSettings,
      routestops,
      preOrderDaysAheadAllowed,
    } = this.props;
    return (
      <div className="app-bar-tabs-container">
        <Tabs
          classes={{ root: this.settingString }}
          indicatorColor="primary"
          textColor="primary"
          scrollButtons="auto"
          variant="scrollable"
          value={this.getModeToId(selectedModeId)}
          onChange={(ev, newValue) => {
            requestAnimationFrame(() => {
              if (newValue === moreKey) {
                if (selectedModeId !== moreKey) {
                  setMode(moreKey, moment().startOf('day').toDate(), moment().endOf('day').toDate());
                }
              } else if (newValue.id == dayKey) {
                setMode(dayKey, moment().startOf('day').toDate(), moment().endOf('day').toDate());
              } else {
                setMode(newValue.id);
              }
            });
          }}
        >
          {selectableDurations.map((duration) => {
            if (duration.id === 'Route' && (!localSettings.enableRouteplanning || routestops.length === 0)) { return null; }

            if (duration.id === 'Morgen' && (!localSettings.showTomorrow)) { return null; }
            if (duration.id === 'Uebermorgen' && (!localSettings.showSecondNextDay)) { return null; }

            if (duration.id === 'Verlauf' && (!localSettings.showOrderHistory)) { return null; }

            return (<Tab
              key={duration.id}
              label={
                <div className={classes.tabelement}>
                  {duration.text}
                  <ButtonBadge mode={duration} />
                </div>
              }
              value={duration}
            />);
          })}
          {preOrderDaysAheadAllowed > 0
            ? (
              <Tab
                label={
                  <DayStepper
                    value={ordersStartDate}
                    onChange={date => setMode(moreKey, moment(date).startOf('day').toDate(), moment(date).endOf('day').toDate())}
                  />
                }
                key={moreKey}
                value={moreKey}
              />
            )
            : null
          }
        </Tabs>
        <div className="filter-tab-container">
          {this.renderProductionPlaceFilterTab()}
          {this.renderOrderSpotFilterTab()}
        </div>
      </div>
    );
  }
}

const styles = theme => ({
  root: {
  },
  tabelement: {
    fontSize: theme.appbar.buttons.fontSize,
  },
});

SubheaderPanel.defaultProps = {
  centered: false,
  ordersProductionPlace: null,
  orderSpot: null,
  ordersStartDate: null,
  productionPlaces: [],
  spots: [],
};


SubheaderPanel.propTypes = {
  selectableDurations: PropTypes.array.isRequired,
  selectedMode: PropTypes.string,
  setProductionPlaceOrderFilter: PropTypes.func.isRequired,
  setOrderSpotFilter: PropTypes.func.isRequired,
  setMode: PropTypes.func.isRequired,
  localSettings: PropTypes.object.isRequired,
  routestops: PropTypes.array.isRequired,
  ordersProductionPlace: PropTypes.number,
  ordersStartDate: PropTypes.any,
  productionPlaces: PropTypes.array,
  spots: PropTypes.array,
  orderSpot: PropTypes.any,
};

export default withStyles(styles)(SubheaderPanel);
